class TopicManager {
  constructor() {
    this.subscribedTopics = []
  }

  getSubscribedTopics() {
    return this.subscribedTopics
  }

  addTopic(topic) {
    this.subscribedTopics.push(topic)
  }

  removeTopic(topic) {
    const idx = this.subscribedTopics.indexOf(topic)
    if (idx > -1) {
      this.subscribedTopics.splice(idx, 1)
    }
  }
}

const topicManager = new TopicManager()

export default topicManager
